export class ScheduledExpiryWarehouseDTO {
  id = '';
  name = '';
  scheduledExpiryAt = '';

  constructor(data: Partial<ScheduledExpiryWarehouseDTO> = {}) {
    Object.assign(this, data);
  }
}

export class ScheduledExpiryServiceTruckDTO {
  id = '';
  name = '';
  registrationNo = '';
  scheduledExpiryAt = '';

  constructor(data: Partial<ScheduledExpiryServiceTruckDTO> = {}) {
    Object.assign(this, data);
  }
}

export class ScheduledExpiryUserDTO {
  id = '';
  name = '';
  email = '';
  scheduledExpiryAt = '';

  constructor(data: Partial<ScheduledExpiryUserDTO> = {}) {
    Object.assign(this, data);
  }
}

export class ScheduledExpiryNoteDTO {
  item = '';
  quantity = 0;
  scheduledExpiryAt = '';
  label = '';

  constructor(data: Partial<ScheduledExpiryNoteDTO> = {}) {
    Object.assign(this, data);
  }
}

export class ScheduledExpiriesResponseDTO {
  warehouses: ScheduledExpiryWarehouseDTO[] = [];
  serviceTrucks: ScheduledExpiryServiceTruckDTO[] = [];
  users: ScheduledExpiryUserDTO[] = [];
  notes: ScheduledExpiryNoteDTO[] = [];

  constructor(data: Partial<ScheduledExpiriesResponseDTO> = {}) {
    this.warehouses = (data.warehouses ?? []).map(item => new ScheduledExpiryWarehouseDTO(item));
    this.serviceTrucks = (data.serviceTrucks ?? []).map(item => new ScheduledExpiryServiceTruckDTO(item));
    this.users = (data.users ?? []).map(item => new ScheduledExpiryUserDTO(item));
    this.notes = (data.notes ?? []).map(item => new ScheduledExpiryNoteDTO(item));
  }
}
